import React from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'

import { BUSINESS_LOGISTICS_ROUTES } from '@constants/routes'
import { decodeSp } from '@utils/spParam'
import MovedNote from '../@components/MovedNote'
import { leadingToView } from '../Dashboards/OfficeNetwork/Page/@services/leadingLink'


/**
 * Leading Analyzer's old address (CU-869fmjzrh R, CA 24). With `bi`: My office network, on its view by pick-up date,
 * with the link's offices, length, websites, dates and filters; the page says what did not travel. Without `bi` (P4):
 * a note that it moved, never a 404. The first piece of a "no access" page (K4).
 */
export default function LeadingRetired({ mode }) {
	const [searchParams] = useSearchParams()
	if (mode === 'redirect') {
		const { params } = leadingToView(decodeSp(searchParams.get('sp')))
		return <Navigate to={`${BUSINESS_LOGISTICS_ROUTES.OFFICE_NETWORK_PATH}?${params}`} replace/>
	}
	return <MovedNote name="Leading Analyzer" replacement={<b>My office network</b>}/>
}
